import { TransferOrderStatus } from './transfer-order-status.js';
export const TRANSFER_ORDER_POST_ISSUE_EDITABLE_STATUS_IDS = [
    TransferOrderStatus.ISSUED,
    TransferOrderStatus.PICK,
];
//# sourceMappingURL=transfer-order-post-issue-editable-status-ids.js.map